import Images from "@/assets/images.js";
const config = {
  aspspProviders: [
    {
      id: "otp",
      label: "Lakossági és vállalati ügyfelek",
      description: "OTP Bank",
      auth: {
        availableAccounts: "/banks/otp/tokens/",
        redirect: "/banks/otp/redirecturl",
      },
      meta: {
        description: "OTP Bank",
        class: "bank-logo--otp",
        image: Images.logos.otp.original,
      },
    },
    {
      id: "budapest",
      label: "MBH Netbank (korábban BB)",
      description: "MBH Netbank (korábban BB)",
      auth: {
        availableAccounts: "/banks/budapest/tokens/",
        redirect: "/banks/budapest/redirecturl",
      },
      meta: {
        class: "bank-logo--bb",
        description: "MBH Bank",
        image: Images.logos.mkb.original,
      },
    },
    {
      id: "mkb",
      label: "MBH Netbank (korábban MKB és Takarék)",
      description: "MBH Netbank (korábban MKB és Takarék)",
      auth: {
        availableAccounts: "/banks/mkb/tokens/",
        redirect: "banks/mkb/redirecturl",
      },
      meta: {
        class: "bank-logo--mkb",
        description: "MBH Bank",
        image: Images.logos.mkb.original,
      },
    },
    {
      id: "erste",
      label: "Erste George ügyfelek",
      description: "Erste Bank",
      auth: {
        availableAccounts: "/banks/erste/tokens/",
        redirect: "/banks/erste/redirecturl",
      },
      meta: {
        description: "Erste George ügyfelek",
        class: "bank-logo--erste",
        image: Images.logos.erste.original,
      },
    },
    {
      id: "raiffeisen",
      label: "Lakossági és vállalati ügyfelek",
      description: "Raiffeisen Bank",
      auth: {
        availableAccounts: "/banks/raiffeisen/tokens/",
        redirect: "/banks/raiffeisen/redirecturl",
      },
      meta: {
        description: "Raiffeisen Bank",
        class: "bank-logo--raiffeisen",
        image: Images.logos.raiffeisen.original,
      },
    },
    {
      id: "cib",
      label: "Lakossági és KKV ügyfelek",
      description: "CIB Bank",
      auth: {
        availableAccounts: "/banks/cib/tokens/",
        redirect: "/banks/cib/redirecturl",
      },
      meta: {
        description: "CIB Bank",
        class: "bank-logo--cib",
        image: Images.logos.cib.original,
      },
    },
    {
      id: "unicredit",
      label: "Lakossági és vállalati ügyfelek",
      description: "UniCredit Bank",
      auth: {
        availableAccounts: "/banks/unicredit/tokens/",
        redirect: "/banks/unicredit/redirecturl",
      },
      meta: {
        description: "UniCredit Bank",
        class: "bank-logo--unicredit",
        image: Images.logos.unicredit.original,
      },
    },
    {
      id: "granit",
      label: "Lakossági és vállalati ügyfelek",
      description: "Gránit Bank",
      auth: {
        availableAccounts: "/banks/granit/tokens/",
        redirect: "banks/granit/redirecturl",
      },
      meta: {
        class: "bank-logo--granit",
        description: "Gránit Bank",
        image: Images.logos.granit.original,
      },
    },
    {
      id: "magnet",
      label: "Lakossági és vállalati ügyfelek",
      description: "Magnet Bank",
      auth: {
        availableAccounts: "/banks/magnet/tokens/",
        redirect: "/banks/magnet/redirecturl",
      },
      meta: {
        description: "Magnet Bank",
        class: "bank-logo--magnet",
        image: Images.logos.magnet.original,
      },
    },
  ],
};

export default config;
